import CustomTableShow from './CustomTableShow';

class ProductTagShow extends CustomTableShow {

    customHandled(fields, fieldName, fieldList) {
        if (fieldName === 'immutable') {
            return true
        }
        return false
    }
}

export default ProductTagShow;
